<template>
  <div class="moderator-marketing-mailings">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <ErrorView v-else-if="error"
               :code="error.code"
               :title="error.message"
               class="container-inner"/>

    <div v-if="options"
         class="moderator-marketing-mailings__content">
      <BasePreloader v-if="fromPending"/>
      <div class="moderator-marketing-mailings__options">
        <AMMarketingMailingsOption v-for="(option, key) in options"
                                   :key="option.id"
                                   :option="option"
                                   :optionKey="key"
                                   :optionType="results[key].type"
                                   v-model="results[key].value"
                                   @input="onCheckQuantityOfReceivers"
                                   class="moderator-marketing-mailings__option"/>

      </div>

      <div class="moderator-marketing-mailings__massages">
        <div v-if="selectedChannel('sms')"
             class="moderator-marketing-mailings__massage-wrap">
          <BaseInput v-model="massages.sms.sms.value"
                     :label="getChangeLabel('sms')"
                     textarea
                     class="moderator-marketing-mailings__massage"/>
          <div class="moderator-marketing-mailings__checkboxes-wrap">
<!--            <div class="moderator-marketing-mailings__checkbox">-->
<!--              <BaseCheckbox v-model="massages.sms.send_link_sms.value"-->
<!--                            :error="massages.sms.send_link_sms.error"-->
<!--                            :label="$tModeratorMarketing('send_link_sms')"/>-->
<!--              <BaseInputError :value="massages.sms.send_link_sms.error"/>-->
<!--            </div>-->
            <div class="moderator-marketing-mailings__checkbox">
              <BaseCheckbox v-model="massages.sms.force_send_sms.value"
                            :error="massages.sms.force_send_sms.error"
                            :label="$tModeratorMarketing('force_send_sms')"/>
              <BaseInputError :value="massages.sms.force_send_sms.error"/>
            </div>
          </div>
        </div>
        <div v-if="selectedChannel('messenger')"
             class="moderator-marketing-mailings__massage-wrap">
          <BaseInput v-model="massages.messenger.messenger.value"
                     :label="getChangeLabel('messenger')"
                     textarea
                     style="margin-bottom: 2rem"
                     class="moderator-marketing-mailings__massage"/>

          <div class="moderator-marketing-mailings__inputs-wrap">
            <BaseInput v-model="massages.messenger.messenger_link.value"
                       :error="massages.messenger.messenger_link.error"
                       :label="$tModeratorMarketing('messenger_link')"
                       style="flex-grow: 1"
                       class="moderator-marketing-mailings__input"/>
          </div>
          <div class="input__label">
            {{ $tModeratorMarketing('messenger_image') }}
          </div>
          <FilesUploadMultiple v-model="massages.messenger.messenger_image.value"
                               :max="1"
                               :filesExtsMixin="filesExtsMixin"
                               :filesMimeTypes="filesMimeTypes"
                               class="moderator-marketing-mailings__input-upload"/>
          <BaseInputError :value="massages.messenger.messenger.error"/>
        </div>

        <div v-if="selectedChannel('bot')"
             class="moderator-marketing-mailings__massage-wrap">
          <BaseInput v-model="massages.bot.bot.value"
                     :label="getChangeLabel('bot')"
                     textarea
                     class="moderator-marketing-mailings__massage"/>
          <BaseInput v-model="massages.bot.link_to_bot.value"
                     :error="massages.bot.link_to_bot.error"
                     :label="$tModeratorMarketing('link_to_bot')"
                     style="margin-top: 2rem"
                     class="moderator-marketing-mailings__massage"/>

<!--          <div class="moderator-marketing-mailings__checkboxes-wrap">-->
<!--            <div class="moderator-marketing-mailings__checkbox">-->
<!--              <BaseCheckbox v-model="massages.bot.send_link_bot.value"-->
<!--                            :error="massages.bot.send_link_bot.error"-->
<!--                            :label="$tModeratorMarketing('send_link_bot')"/>-->
<!--              <BaseInputError :value="massages.bot.send_link_bot.error"/>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <div v-if="selectedChannel('site')"
             class="moderator-marketing-mailings__massage-wrap">
          <BaseInput v-model="massages.site.site.value"
                     :label="getChangeLabel('site')"
                     textarea
                     class="moderator-marketing-mailings__massage"/>
        </div>

        <div v-if="selectedChannel('email')"
             class="moderator-marketing-mailings__massage-wrap">
          <div class="moderator-marketing-mailings__inputs-wrap">
            <BaseInput v-model="massages.email.email_title.value"
                       :error="massages.email.email_title.error"
                       :label="$tModeratorMarketing('email_title')"
                       class="moderator-marketing-mailings__input"/>
            <BaseInput v-model="massages.email.email_subject.value"
                       :error="massages.email.email_subject.error"
                       :label="$tModeratorMarketing('email_subject')"
                       class="moderator-marketing-mailings__input"/>
            <BaseInput v-model="massages.email.email_link.value"
                       :error="massages.email.email_link.error"
                       :label="$tModeratorMarketing('email_link')"
                       class="moderator-marketing-mailings__input"/>
          </div>
          <div class="moderator-marketing-mailings__massage">
            <div class="input__label">
              {{ getChangeLabel('email') }}
            </div>
            <Editor v-model="massages.email.email.value"/>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 3rem">
        <h3 class="moderator-marketing-mailings__group-title">
          {{ $tModeratorMarketing('Mailing purpose') }}
        </h3>
        <BaseInput v-model="mailing_target.value"
                   class="moderator-marketing-mailings__massage"/>
      </div>

      <BaseAlert :value="overallErrorsMix"
                 class="moderator-marketing-mailings__error  _warning"/>
      <div class="moderator-marketing-mailings__footer">
        <button @click.prevent="onSend"
                class="moderator-marketing-mailings__btn-send  base-btn  base-btn--blue">
          {{ $tModeratorMarketing('Send') }}
        </button>

        <div v-if="typeof receiversQuantity === 'number'"
             class="moderator-marketing-mailings__receivers-quantity">
          {{ $tModeratorMarketing('Receivers quantity:') }} <b>{{ receiversQuantity }}</b>
          <div>
            <span style="margin-right: 1rem">{{ $tModeratorMarketing('SMS cost:') }} <b>{{ costSms }}</b></span>
            <span>{{ $tModeratorMarketing('Viber cost:') }} <b>{{ costViber }}</b></span>
          </div>
          <BasePreloader v-if="pendingCheckQuantity"
                         class="_small"/>
        </div>
      </div>

    </div>

    <AMMarketingMailingsHistory v-if="options"
                                :key="counter"
                                :getChangeLabel="getChangeLabel"
                                class="moderator-marketing-mailings__history"/>
  </div>
</template>

<script>
  import {CancelToken} from 'axios';
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'
  import formMixins from '@/mixins/formMixins'
  import ErrorView from '@/components/ErrorView'
  import BaseInputError from '@/components/BaseInputError'
  import FilesUploadMultiple from '@/components/FilesUploadMultiple'
  import AMMarketingMailingsOption from '@/components/moderatorMarketingMailings/AMMarketingMailingsOption'
  import AMMarketingMailingsHistory from '@/components/moderatorMarketingMailings/AMMarketingMailingsHistory'
  import {ALLOWED_IMAGES_EXTS, ALLOWED_VIDEOS_EXTS, IMAGES_MIME_TYPES, VIDEOS_MIME_TYPES} from "@/constants/files"

  const Editor = () => import(
    /* webpackChunkName: "editor" */ '@/components/Editor'
    );

  function getResultsInputs() {
    return {
      role: {
        type: 'many',
        value: null
      },
      have_sent: {
        type: 'one',
        value: null
      },
      bot_subscribe: {
        type: 'one',
        value: null
      },
      have_favorites: {
        type: 'one',
        value: null
      },
      have_primary: {
        type: 'one',
        value: null
      },
      age: {
        type: 'many',
        value: null
      },
      gender: {
        type: 'many',
        value: null
      },
      place: {
        type: 'many',
        value: null
      },
      channels: {
        type: 'many',
        value: null
      },
    }
  }

  function getMessagesInput() {
    return {
      sms: {
        sms: {
          value: null
        },
        // send_link_sms: {
        //   value: false
        // },
        force_send_sms: {
          value: false
        },
      },
      bot: {
        bot: {
          value: null
        },
        // send_link_bot: {
        //   value: null
        // },
        link_to_bot: {
          value: null
        }
      },
      site: {
        site: {
          value: null
        },
      },
      email: {
        email: {
          value: null
        },
        email_title: {
          value: null
        },
        email_subject: {
          value: null
        },
        email_link: {
          value: null
        },
      },
      messenger: {
        messenger: {
          value: null
        },
        messenger_link: {
          value: null
        },
        messenger_image: {
          value: []
        }
      },
    }
  }

  function getMailingTargetInput() {
    return {
      value: null
    }
  }

  export default {
    name: 'AccountModeratorMarketingMailingsPage',
    mixins: [formMixins],
    components: {
      ErrorView,
      BaseInputError,
      FilesUploadMultiple,
      AMMarketingMailingsOption,
      AMMarketingMailingsHistory,
      Editor
    },
    data() {
      return {
        error: null,
        pending: false,
        options: null,
        results: getResultsInputs(),
        massages: getMessagesInput(),
        mailing_target: getMailingTargetInput(),
        fromPending: false,
        counter: 1,

        pendingCheckQuantity: false,
        receiversQuantity: null,
        costSms: null,
        costViber: null,
        cancel: null,

        filesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS],
        filesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES],
      }
    },
    methods: {
      load() {
        this.pending = true

        return http.get('/api/backoffice/mailing/datalist')
          .then(({data}) => {
            this.options = data.data
          })
          .catch(e => {
            this.error = {
              code: e.response && e.response.status,
              message: handleError(e)
            }
          })
          .finally(() => {
            this.pending = false
          })
      },
      onSend() {
        this.fromPending = true

        this.resetErrorsMix(this.results)
        for (const key in this.massages) {
          this.resetErrorsMix(this.massages[key])
        }
        this.$set(this.mailing_target, 'error', null)

        const sendData = this.getSendData()

        http.post('/api/backoffice/mailing/create', sendData)
          .then(() => {
            this.$vModal.open('successfully-sent', {
              title: this.$tModeratorMarketing('successfully_sent_title'),
              text: this.$tModeratorMarketing('successfully_sent_message')
            })

            this.resetForm()
            this.counter++

            if (Object.keys(this.$route.query).length) {
              this.$router.push({name: 'account-moderator-marketing-mailing'})
                .catch(() => ({}))
            }
          })
          .catch(e => {
            this.parseErrors(e)
          })
          .finally(() => {
            this.fromPending = false
          })
      },
      onCheckQuantityOfReceivers() {
        this.pendingCheckQuantity = true
        const sendData = {}

        const results = this.results

        for (const key in results) {
          const value = results[key].value

          if (results[key].type === 'many') {
            if (!Array.isArray(value) || !value.length) {
              sendData[key] = ''
            } else {
              sendData[key] = value.map(r => r.key)
            }
          } else {
            sendData[key] = value ? value.key : ''
          }
        }

        if (this.cancel) {
          this.cancel()
          this.cancel = null
        }

        http.get('/api/backoffice/mailing/customers', {
          cancelToken: new CancelToken((c) => {
            this.cancel = c;
          }),
          params: sendData
        })
          .then(({data}) => {
            this.receiversQuantity = data.data || 0
            this.costSms = data.sms_cost || 0
            this.costViber = data.viber_cost || 0
          })
          .finally(() => {
            this.pendingCheckQuantity = false
          })
      },
      getSendData(isTest) {
        const formData = new FormData()

        const results = this.results

        for (const key in results) {
          const value = results[key].value

          if (results[key].type === 'many') {
            if (!Array.isArray(value) || !value.length) {
              formData.append(key, '')
            } else {
              value.forEach(r => {
                formData.append(`${key}[]`, r.key)
              })
            }
          } else {
            formData.append(key, value ? value.key : '')
          }
        }

        const massages = this.massages

        for (const groupKey in massages) {
          const isSelectedChannel = this.selectedChannel(groupKey)
          const group = massages[groupKey]

          for (const key in group) {
            if (isSelectedChannel) {
              const massage = group[key]
              let value = massage.value

              value = isEmptyField(value) ? '' : value
              formData.append(key, value)
            } else {
              formData.append(key, '')
            }
          }
        }

        formData.append('mailing_target', isEmptyField(this.mailing_target.value) ? '' : this.mailing_target.value)

        if (isTest) {
          formData.delete('messenger_image')
        } else {
          formData.set('messenger_image', this.$get(this.massages.messenger.messenger_image, 'value[0].file', ''))
        }

        return formData
      },
      parseErrors(e) {
        const errors = this.$get(e, 'response.data.errors')

        this.errorHandlerMix(e, this.results)
        this.errorHandlerMix(e, this.massages)
        this.$set(this.mailing_target, 'error', errors['mailing_target'] || null)
      },

      resetForm() {
        this.results = getResultsInputs()
        this.massages = getMessagesInput()
        this.mailing_target = getMailingTargetInput()
      },

      selectedChannel(key) {
        const channels = this.results.channels.value

        if (!channels || !channels.length) return false

        return channels.some(c => c.key === key)
      },
      getChangeLabel(key) {
        const channel = this.options.channels.find(c => c.key === key)

        return channel && channel.label
      }
    },
    created() {
      this.load()
    }
  }

  function isEmptyField(value) {
    return !!(value === null || value === '' || value === undefined)
  }
</script>

<style lang="less">

</style>
